import React from "react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Twitter, Instagram, Github, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Footer() {
  const { user } = useAuth();
  const isAdmin = user && user.role === "admin";
  return (
    <footer data-testid="footer" className="border-t border-[#1D2640] bg-[#0B0E1B] mt-24">
      <div className="px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2 md:col-span-1">
            <div className="mb-4">
              <Logo size={38} />
            </div>
            <p className="font-mono-caption text-xs uppercase tracking-[0.22em] text-cyan-300 mb-3">See it. Book it. Go.</p>
            <p className="text-sm text-slate-400 leading-relaxed">
              The premium Caribbean travel marketplace. Curated villas, charters, and once-in-a-lifetime experiences.
            </p>
            <div className="flex gap-3 mt-5">
              {[Twitter, Instagram, Github].map((Icon, i) => (
                <a key={i} href="#" className="w-9 h-9 rounded-full glass flex items-center justify-center text-slate-300 hover:text-cyan-400 glass-hover">
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-mono-caption text-xs uppercase tracking-[0.2em] text-cyan-400 mb-4">Experiences</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><Link to="/atv-tours" className="hover:text-cyan-400">ATV & Off-Road Tours</Link></li>
              <li><Link to="/boat-tours" className="hover:text-cyan-400">Boat Tours & Sailing</Link></li>
              <li><Link to="/water-activities" className="hover:text-cyan-400">Water Activities</Link></li>
              <li><Link to="/shore-excursions" className="hover:text-cyan-400">Shore Excursions</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-mono-caption text-xs uppercase tracking-[0.2em] text-cyan-400 mb-4">Company</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><Link to="/about" className="hover:text-cyan-400">About</Link></li>
              <li><Link to="/faq" className="hover:text-cyan-400">FAQ</Link></li>
              <li><Link to="/register" className="hover:text-cyan-400">Become a host</Link></li>
              <li><Link to="/become-an-agent" className="hover:text-cyan-400" data-testid="footer-affiliate-link">Affiliate Program</Link></li>
              <li><Link to="/contact" className="hover:text-cyan-400">Contact</Link></li>
              <li><Link to="/privacy" className="hover:text-cyan-400">Privacy Policy</Link></li>
              <li><Link to="/terms" className="hover:text-cyan-400">Terms of Service</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-mono-caption text-xs uppercase tracking-[0.2em] text-cyan-400 mb-4">Destinations</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><Link to="/grenada" className="hover:text-cyan-400">Grenada</Link></li>
              <li><Link to="/st-vincent" className="hover:text-cyan-400">St. Vincent &amp; Grenadines</Link></li>
              <li><Link to="/saint-lucia" className="hover:text-cyan-400">Saint Lucia</Link></li>
              <li><Link to="/barbados" className="hover:text-cyan-400">Barbados</Link></li>
              <li><Link to="/turks-caicos" className="hover:text-cyan-400">Turks &amp; Caicos</Link></li>
              <li><Link to="/browse" className="hover:text-cyan-400">All experiences</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-[#1D2640] flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-slate-500">
          <p>© {new Date().getFullYear()} Carivisor. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <p className="font-mono-caption">Crafted for the Caribbean · Neon Deep Sea Edition</p>
            <Link
              to={isAdmin ? "/admin" : "/admin-login"}
              data-testid="footer-admin-link"
              className="inline-flex items-center gap-1 text-slate-600 hover:text-cyan-400 transition-colors"
              title={isAdmin ? "Admin dashboard" : "Admin login"}
            >
              <ShieldCheck className="w-3 h-3" /> {isAdmin ? "Dashboard" : "Admin"}
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
